import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "form",
    "original",
    "originalEdit",
    "originalEditButton",
    "originalSaveButton",
    "translation",
    "translationEdit",
    "translationEditButton",
    "translationSaveButton",
    "finalGuidance",
    "finalGuidanceEdit",
    "finalGuidanceEditButton",
    "finalGuidanceSaveButton",
    "modal"
  ];
  static classes = ["hide","open"];
  static values = {savedrafturl: String, saveurl: String};

  editForm(event){
    event.preventDefault();
    const t = event.params.target;
    this.swichEdit(t);
  }

  saveDraft(event){
    event.preventDefault();
    const params = event.params;
    const targetName = params.target;
    const formData = new FormData(this.formTarget);
    formData.append("type",targetName);
    Rails.ajax({
      url: this.savedrafturlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        document.getElementById("mail_medication_guidance_id").value = response.id;
        switch (targetName) {
          case "original":
            this.originalTarget.innerText = response.text;
            const odd = this.originalEditButtonTarget.querySelector("span");
            odd.classList.remove(this.hideClass);
            this.swichEdit("original");
            break;
          case "translation":
            this.translationTarget.innerText = response.text;
            const tdd = this.translationEditButtonTarget.querySelector("span");
            tdd.classList.remove(this.hideClass);
            this.swichEdit("translation");
            break;
          case "final_guidance":
            this.finalGuidanceTarget.innerText = response.text;
            const tfd = this.finalGuidanceEditButtonTarget.querySelector("span");
            tfd.classList.remove(this.hideClass);
            this.swichEdit("finalGuidance");
            break;
        }
      }
    });
  }
  save(event){
    event.preventDefault();
    const params = event.params;
    const targetName = params.target;
    const formData = new FormData(this.formTarget);
    formData.append("type",targetName);
    Rails.ajax({
      url: this.saveurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        document.getElementById("mail_medication_guidance_id").value = response.id;
        switch (targetName) {
          case "original":
            this.originalTarget.innerText = response.text;
            const odd = this.originalEditButtonTarget.querySelector("span");
            odd.classList.add(this.hideClass);
            this.swichEdit("original");
            break;
          case "translation":
            this.translationTarget.innerText = response.text;
            const tdd = this.translationEditButtonTarget.querySelector("span");
            tdd.classList.add(this.hideClass);
            this.swichEdit("translation");
            break;
          case "final_guidance":
            this.finalGuidanceTarget.innerText = response.text;
            const tfd = this.finalGuidanceEditButtonTarget.querySelector("span");
            tfd.classList.add(this.hideClass);
            this.swichEdit("finalGuidance");
            break;
        }
      }
    });
  }

  swichEdit(target){
    switch (target) {
      case "original":
        this.originalTarget.classList.toggle(this.hideClass);
        this.originalEditTarget.classList.toggle(this.hideClass);
        this.originalEditButtonTarget.classList.toggle(this.hideClass);
        this.originalSaveButtonTarget.classList.toggle(this.hideClass);
        break;
      case "translation":
        this.translationTarget.classList.toggle(this.hideClass);
        this.translationEditTarget.classList.toggle(this.hideClass);
        this.translationEditButtonTarget.classList.toggle(this.hideClass);
        this.translationSaveButtonTarget.classList.toggle(this.hideClass);
        break;
      case "finalGuidance":
        this.finalGuidanceTarget.classList.toggle(this.hideClass);
        this.finalGuidanceEditTarget.classList.toggle(this.hideClass);
        this.finalGuidanceEditButtonTarget.classList.toggle(this.hideClass);
        this.finalGuidanceSaveButtonTarget.classList.toggle(this.hideClass);
        break;
    }
  }

  modal(event) {
    event.preventDefault();
    this.modalTarget.classList.toggle(this.openClass);
    const params = event.params;
    if(params != undefined){
      const b = this.modalTarget.querySelector("button.is-primary");
      const ns = document.getElementById("next_status");
      b.setAttribute("data-admin--reservations--edit-mail-medication-guidance-target-param",params.target);
      switch (params.target){
        case "original":
          ns.innerHTML = "<span class=\"tag is-primary\">服薬指導翻訳待ち</span>";
          break;
        case "translation":
          ns.innerHTML = "<span class=\"tag is-info\">服薬指導承認待ち</span>";
          break;
        case "final_guidance":
          ns.innerHTML = "<span class=\"tag is-primary\">服薬指導公開待ち</span>";
          break;
      }
    }
  }
}
